import React, { useState } from 'react';
import { Container, Form, Button, Card, Row, Col, Alert } from 'react-bootstrap';
import { QRCodeSVG } from 'qrcode.react';

const GenerateQR = () => {
  const [formData, setFormData] = useState({
    itemName: '',
    contactInfo: '',
    message: '',
    includeContact: true
  });
  
  const [qrGenerated, setQrGenerated] = useState(false);
  const [qrValue, setQrValue] = useState('');
  
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Generate QR code content
    const contactInfo = formData.includeContact ? formData.contactInfo : '';
    const qrContent = JSON.stringify({
      item: formData.itemName,
      contact: contactInfo,
      message: formData.message
    });
    
    setQrValue(qrContent);
    setQrGenerated(true);
  };
  
  const handleDownload = () => {
    // In a real app, this would generate a downloadable QR code
    alert('In a real application, this would download the QR code as an image file.');
  };
  
  return (
    <Container>
      <h1 className="mb-4">Generate QR Code</h1>
      
      <Row>
        <Col md={6}>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title>QR Code Details</Card.Title>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="itemName">
                  <Form.Label>Item Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="itemName"
                    value={formData.itemName}
                    onChange={handleChange}
                    placeholder="e.g., Laptop, Phone, Wallet"
                    required
                  />
                </Form.Group>
                
                <Form.Group className="mb-3" controlId="contactInfo">
                  <Form.Label>Contact Information</Form.Label>
                  <Form.Control
                    type="text"
                    name="contactInfo"
                    value={formData.contactInfo}
                    onChange={handleChange}
                    placeholder="e.g., Email or Phone Number"
                  />
                </Form.Group>
                
                <Form.Group className="mb-3" controlId="includeContact">
                  <Form.Check
                    type="checkbox"
                    name="includeContact"
                    checked={formData.includeContact}
                    onChange={handleChange}
                    label="Include contact information in QR code"
                  />
                </Form.Group>
                
                <Form.Group className="mb-3" controlId="message">
                  <Form.Label>Message for Finder</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={3}
                    placeholder="Message to display when QR code is scanned"
                    required
                  />
                </Form.Group>
                
                <Button variant="primary" type="submit">
                  Generate QR Code
                </Button>
              </Form>
            </Card.Body>
          </Card>
          
          <Alert variant="info">
            <Alert.Heading>How to use your QR code</Alert.Heading>
            <p>
              Once generated, you can download your QR code and print it. 
              Attach it to your personal belongings for added security.
            </p>
            <hr />
            <p className="mb-0">
              When someone scans your QR code, they will see your custom message
              and contact information (if you chose to include it).
            </p>
          </Alert>
        </Col>
        
        <Col md={6}>
          {qrGenerated && (
            <Card className="text-center">
              <Card.Body>
                <Card.Title>Your QR Code</Card.Title>
                <div className="my-4 d-flex justify-content-center">
                  <QRCodeSVG
                    value={qrValue}
                    size={200}
                    level="H"
                    includeMargin={true}
                    imageSettings={{
                      src: "https://via.placeholder.com/40",
                      x: undefined,
                      y: undefined,
                      height: 40,
                      width: 40,
                      excavate: true,
                    }}
                  />
                </div>
                <p>
                  <strong>Item:</strong> {formData.itemName}<br />
                  {formData.includeContact && (
                    <><strong>Contact:</strong> {formData.contactInfo}<br /></>
                  )}
                  <strong>Message:</strong> {formData.message}
                </p>
                <Button variant="success" onClick={handleDownload}>
                  Download QR Code
                </Button>
              </Card.Body>
            </Card>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default GenerateQR;